<div class="invite-user-container">
  <nz-form-item>
    <nz-form-label nzRequired="true">{{'Email' | translate}}</nz-form-label>
    <nz-form-control>
      <input type="email" nz-input [(ngModel)]="user.email" />
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label>{{'Name' | translate}}</nz-form-label>
    <nz-form-control>
      <input type="text" nz-input [(ngModel)]="user.name" />
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label>{{'Position' | translate}}</nz-form-label>
    <nz-form-control>
      <input type="text" nz-input [(ngModel)]="user.position" />
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label>{{'Roles' | translate}}</nz-form-label>
    <nz-form-control>
      <nz-select  [nzAllowClear]="true"
       [(ngModel)]="user.role" >
        <nz-option
         
          *ngFor="let role of roles"
          [nzValue]="role.id"
          [nzLabel]="role.name"
        ></nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>
  <button nz-button nzType="primary" (click)="inviteUser()">{{'Invite' | translate}}</button>
</div>
